import getEventTargetValue from '../../utils/get-event-target-value';
import { changeCountrySplit } from '../actions';
import { connectEditor } from '../connect-editor';
import ApplyCWTemplateButton from './ApplyCWTemplateButton';

export default connectEditor(
  ({ quoteLinesById, quote }) => {
    const quoteLines = quote.quoteLines.map(each => quoteLinesById[each]);

    return {
      quoteLines,
    };
  },
  {
    onChangeCountrySplit: event =>
      changeCountrySplit(
        event.target.dataset.quoteLineId,
        event.target.dataset.countryCode,
        getEventTargetValue(event.target),
      ),
  },
)(ApplyCWTemplateButton);
